export default [
    {
        path: '/search',

        name: 'Company Search',

        component: () => import('@/views/pages/search'),
    },
];